export default "__VITE_ASSET__2FHJX0pS__"